import React from 'react';
import './Footer.css';

const Footer = () => (
<div className='footer'>
  <p className='footer-text top'> Built with React &#9829; </p>
  <p className='footer-text'>Created and Maintained by Akil M Hylton</p>
</div>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/container/Footer/Footer.js